<template>
    <div class="privacy-custom__info">
        {{ $t('I agree with the use of my personal data by Superbet to receive, through the ' +
            'means of communication made available based on my player profile analysis and opinion ' +
            'polls in this regard, personalized offers about promotions and / or bonuses.') }}
        <br>
        <StaticLink
            tag="a"
            class="action-text"
            :path="$WikiPath.DataProtection"
            target="_blank"
        >
            {{ $capitalize($t('view the privacy statement').toString()) }}
        </StaticLink>
    </div>
</template>

<script>
    export default {
        name: 'PrivacyConsentCustomInfo',
    };
</script>
